export default __webpack_public_path__ + "static/media/school_logo_demo.7cd898e8.png";